import { Form, DatePicker, TimePicker, Button, Space, message, Modal, Alert, ConfigProvider } from "antd";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import esES from "antd/lib/locale/es_ES";
import { Link } from "react-router-dom";
moment.locale("es-mx");

export default function AddVisitForm(props) {
  const { id, setVisits, visible, setVisible, preselectedDate } = props;
  const [form] = Form.useForm();
  const [overlappingVisits, setOverlappingVisits] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [inicioOpen, setInicioOpen] = useState(false);
  const [terminoOpen, setTerminoOpen] = useState(false);
  const prevInicio = useRef(null);
  const prevTermino = useRef(null);

  const checkOverlapping = () => {
    const fecha = form.getFieldValue("FechaVisita");
    const inicio = form.getFieldValue("HoraInicio");
    const termino = form.getFieldValue("HoraTermino");

    if (fecha && inicio && termino) {
      const startTimestamp = moment(fecha).format("YYYY-MM-DD") + " " + moment(inicio).format("HH:mm:ss");
      const endTimestamp = moment(fecha).format("YYYY-MM-DD") + " " + moment(termino).format("HH:mm:ss");

      axios
        .get(`${process.env.REACT_APP_API_URL}/visitas/timeoverlap/${startTimestamp}/${endTimestamp}`)
        .then((res) => {
          setOverlappingVisits(res.data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Error al verificar visitas superpuestas");
        });
    } else {
      setOverlappingVisits([]);
    }
  };

  useEffect(() => {
    if (visible) {
      form.resetFields();
      prevInicio.current = null;
      prevTermino.current = null;
      if (preselectedDate) {
        form.setFieldsValue({
          FechaVisita: moment(preselectedDate),
        });
      }
      checkOverlapping();
    }
  }, [visible, form, preselectedDate]);

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setSubmitting(true);
        axios
          .post(`${process.env.REACT_APP_API_URL}/visitas`, {
            VerificacionID: id || values.VerificacionID,
            FechaVisita: moment.utc(values.FechaVisita).format("YYYY-MM-DD"),
            HoraInicio: moment(values.HoraInicio, "HH:mm:ss").format("HH:mm:ss"),
            HoraTermino: moment(values.HoraTermino, "HH:mm:ss").format("HH:mm:ss"),
          })
          .then((res) => {
            setSubmitting(false);
            setVisible(false);
            message.success("Visita agregada");
            if (setVisits && id) {
              axios
                .get(`${process.env.REACT_APP_API_URL}/visitas/${id}`)
                .then((res) => {
                  setVisits(res.data);
                  message.success("Lista de visitas actualizada");
                })
                .catch((err) => {
                  console.log("Error al obtener las visitas", err);
                });
            }
            if (props.onSuccess) {
              props.onSuccess();
            }
          })
          .catch((err) => {
            setSubmitting(false);
            console.log("Error al agregar la visita", err);
            message.error("Error al agregar la visita");
          });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al validar los campos");
      });
  };

  const renderTerminoButtons = () => {
    const inicio = form.getFieldValue("HoraInicio");
    if (!inicio) return <div style={{ padding: '4px 8px', fontSize: '11px', color: '#999' }}>Seleccione inicio primero</div>;

    const intervals = [1, 1.5, 2, 2.5, 3];
    return (
      <div style={{ padding: '4px 8px', display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
        {intervals.map((hours) => (
          <Button
            key={hours}
            size="small"
            type="dashed"
            style={{ fontSize: '11px', height: '22px', padding: '0 4px' }}
            onClick={() => {
              const newTermino = moment(inicio).add(hours, "hours");
              form.setFieldsValue({ HoraTermino: newTermino });
              setTerminoOpen(false);
              checkOverlapping();
            }}
          >
            +{hours}h
          </Button>
        ))}
      </div>
    );
  };

  return (
    <ConfigProvider locale={esES}>
      <Modal title="Agregar Visita" visible={visible} onCancel={() => setVisible(false)} footer={null}>
        <Form form={form} layout="vertical">
          <Form.Item name="FechaVisita" label="Fecha de la visita" rules={[{ required: true, message: "Escriba la fecha de la visita" }]}>
            <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} disabled={!!preselectedDate} />
          </Form.Item>
          <Form.Item name="HoraInicio" label="Hora de inicio" rules={[{ required: true, message: "Seleccione la hora" }]}>
            <TimePicker
              format="HH:mm"
              style={{ width: "100%" }}
              minuteStep={5}
              open={inicioOpen}
              onOpenChange={(open) => {
                setInicioOpen(open);
                if (!open) checkOverlapping();
              }}
              onSelect={(val) => {
                form.setFieldsValue({ HoraInicio: val });
                const prev = prevInicio.current;
                if (prev && prev.hours() === val.hours() && prev.minutes() !== val.minutes()) {
                  setInicioOpen(false);
                  checkOverlapping();
                }
                prevInicio.current = val;
              }}
            />
          </Form.Item>
          <Form.Item name="HoraTermino" label="Hora de Término" rules={[{ required: true, message: "Seleccione la hora" }]}>
            <TimePicker
              format="HH:mm"
              style={{ width: "100%" }}
              minuteStep={5}
              open={terminoOpen}
              onOpenChange={(open) => {
                setTerminoOpen(open);
                if (!open) checkOverlapping();
              }}
              onSelect={(val) => {
                form.setFieldsValue({ HoraTermino: val });
                const prev = prevTermino.current;
                if (prev && prev.hours() === val.hours() && prev.minutes() !== val.minutes()) {
                  setTerminoOpen(false);
                  checkOverlapping();
                }
                prevTermino.current = val;
              }}
              renderExtraFooter={renderTerminoButtons}
            />
          </Form.Item>
        </Form>
        {overlappingVisits.length > 0 && (
          <Alert
            message="Visitas superpuestas"
            description={
              <ul>
                {overlappingVisits.map((visit) => (
                  <li key={visit.VerificacionID}>
                    Control Interno:{" "}
                    <Link to={`/verificaciones/${visit.VerificacionID}`}>
                      {visit.ControlInterno}
                    </Link>
                    {` - Inicia: ${visit.IniciaVisita}, Termina: ${visit.TerminaVisita}`}
                  </li>
                ))}
              </ul>
            }
            type="warning"
            showIcon
            style={{ marginBottom: "16px" }}
          />
        )}
        <Space>
          <Button type="primary" onClick={onSubmit} loading={submitting}>
            Agregar
          </Button>
          <Button onClick={() => setVisible(false)} disabled={submitting}>
            Cancelar
          </Button>
        </Space>
      </Modal>
    </ConfigProvider>
  );
}